{
  "name": "@tailorventures/fg_filemanager",
  "private": false,
  "publishConfig": {
    "registry": "https://npm.pkg.github.com"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/tailorventures/fg_filemanager.git"
  },
  "engines": {
    "node": "24.x",
    "npm": "11.x"
  },
  "type": "module",
  "version": "4.8.4.12",
  "scripts": {
    "a11y:contrast": "tsx scripts/audit-theme-contrast.ts",
    "check:e2e-routes": "tsx scripts/check-e2e-route-coverage.ts",
    "dev": "vite",
    "dev:e2e": "E2E_DEV=1 vite --host 127.0.0.1 --port 3000 --strictPort",
    "build": "vite build",
    "lint": "eslint . --max-warnings 0",
    "typecheck": "tsc --noEmit",
    "preview": "vite preview",
    "format": "prettier --write .",
    "clean:branches": "./scripts/clean-local-branches.sh",
    "test": "vitest run",
    "test:ci": "CI=true NODE_OPTIONS=--max-old-space-size=4096 vitest run",
    "test:watch": "vitest",
    "test:run": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:coverage:ci": "CI=true NODE_OPTIONS=--max-old-space-size=4096 vitest run --coverage",
    "test:coverage:core": "COVERAGE_PROFILE=core vitest run --coverage",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "cypress:run:emails": "cypress run --browser chrome --spec cypress/e2e/emails/emails-routes.smoke.cy.ts",
    "cypress:run:maintenance": "cypress run --browser chrome --spec cypress/e2e/system/maintenance-mode.cy.ts",
    "preview:e2e": "E2E_DEV=1 vite preview --host 127.0.0.1 --port 3000 --strictPort",
    "cypress:run:stub:login": "cypress run --browser chrome --spec cypress/e2e/login/login.smoke.cy.ts,cypress/e2e/login/login.a11y.cy.ts,cypress/e2e/login/login.otp-stub.cy.ts",
    "cypress:run:stub:settings": "cypress run --browser chrome --spec cypress/e2e/settings/settings-hub.smoke.cy.ts && npx tsx scripts/run-settings-slug-smokes.ts",
    "cypress:run:stub:app": "node scripts/run-cypress-specs-sequentially.mjs cypress/e2e/files/files-sections.smoke.cy.ts cypress/e2e/files/personal.smoke.cy.ts cypress/e2e/files/public-link.cy.ts cypress/e2e/files/quick-share.cy.ts cypress/e2e/main/main-routes.smoke.cy.ts",
    "cypress:run:stub:auth": "node scripts/run-cypress-specs-sequentially.mjs cypress/e2e/auth/auth-external-routes.smoke.cy.ts cypress/e2e/auth/logout.cy.ts cypress/e2e/auth/oauth-callback.cy.ts cypress/e2e/admin/users.smoke.cy.ts cypress/e2e/admin/groups.smoke.cy.ts cypress/e2e/admin/activity-logs.smoke.cy.ts cypress/e2e/viewer/viewer.smoke.cy.ts cypress/e2e/system/fallback.smoke.cy.ts",
    "cypress:run:stub": "npm run cypress:run:stub:login && npm run cypress:run:stub:settings && npm run cypress:run:stub:app && npm run cypress:run:stub:auth",
    "e2e": "npm run check:e2e-routes && start-server-and-test dev:e2e http://127.0.0.1:3000 cypress:run",
    "e2e:stub": "npm run check:e2e-routes && start-server-and-test dev:e2e http://127.0.0.1:3000 cypress:run:stub",
    "e2e:emails": "npm run check:e2e-routes && VITE_APP_EMAIL_ENABLED=true CYPRESS_emailEnabled=true start-server-and-test dev:e2e http://127.0.0.1:3000 cypress:run:emails",
    "e2e:maintenance": "npm run check:e2e-routes && VITE_APP_MAINTENANCE_MODE=true CYPRESS_maintenanceMode=true start-server-and-test dev:e2e http://127.0.0.1:3000 cypress:run:maintenance",
    "e2e:real-dev-login": "start-server-and-test dev:e2e http://127.0.0.1:3000 \"cypress run --spec cypress/e2e/login/login.real-dev.cy.ts\"",
    "docker:build": "docker buildx build --platform linux/amd64,linux/arm64 -t fg_filemanager .",
    "docker:run": "docker run -p 8080:8080 fg_filemanager",
    "docker:start": "npm run docker:build && npm run docker:run",
    "docker:stop": "docker stop $(docker ps -q --filter ancestor=fg_filemanager)",
    "docker:publish": "docker buildx build --platform linux/amd64,linux/arm64 -t cybergrantregistry-cuash9ckhse5gcha.azurecr.io/filegrant-fe:latest --push ."
  },
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "dependencies": {
    "@ant-design/x": "^2.9.0",
    "@ant-design/x-markdown": "^2.9.0",
    "@azure/msal-browser": "^5.25.1",
    "@azure/msal-react": "^5.7.2",
    "@kenjiuno/msgreader": "^1.28.0",
    "@microsoft/signalr": "^10.0.11",
    "@monaco-editor/react": "^4.7.0",
    "@pdf-viewer/react": "^1.19.2",
    "@sentry/react": "^11.7.0",
    "@simplewebauthn/browser": "^14.0.0",
    "@stripe/react-stripe-js": "^7.0.0",
    "@stripe/stripe-js": "^10.1.0",
    "aes-js": "^3.1.2",
    "antd": "6.6.6",
    "axios": "^1.20.0",
    "chart.js": "^4.5.1",
    "clsx": "2.1.1",
    "dayjs": "1.11.23",
    "dexie": "^4.4.6",
    "dompurify": "^3.4.17",
    "file-type": "22.1.1",
    "hash-wasm": "^4.12.0",
    "i18next": "26.4.4",
    "i18next-http-backend": "4.0.2",
    "ical.js": "^2.2.1",
    "lucide-react": "^1.57.0",
    "overlayscrollbars": "^2.16.0",
    "overlayscrollbars-react": "^0.5.6",
    "pdf-lib": "^1.17.1",
    "postal-mime": "^4.0.6",
    "qs": "6.16.0",
    "react": "^19.3.0",
    "react-chartjs-2": "^5.3.1",
    "react-dom": "^19.3.0",
    "react-file-icon": "^1.6.0",
    "react-i18next": "17.0.16",
    "react-router-dom": "7.18.4",
    "react-simple-maps": "^5.0.5",
    "sortablejs": "^1.15.7",
    "topojson-client": "^3.1.0",
    "zustand": "^5.0.15"
  },
  "devDependencies": {
    "@commitlint/cli": "^21.2.3",
    "@commitlint/config-conventional": "^21.2.3",
    "@eslint/js": "^9.39.5",
    "@sentry/vite-plugin": "^5.4.1",
    "@tailwindcss/postcss": "^4.3.3",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.8",
    "@types/aes-js": "^3.1.4",
    "@types/file-type": "^10.9.3",
    "@types/jest-axe": "^3.5.9",
    "@types/node": "^26.6.5",
    "@types/qs": "^6.15.1",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@types/react-simple-maps": "^3.0.6",
    "@types/sortablejs": "^1.15.9",
    "@types/topojson-client": "^3.1.5",
    "@typescript-eslint/eslint-plugin": "8.71.2",
    "@typescript-eslint/parser": "8.71.2",
    "@vitejs/plugin-react": "6.0.2",
    "@vitest/coverage-v8": "^5.0.4",
    "autoprefixer": "10.6.1",
    "cypress": "^15.21.1",
    "cypress-axe": "^1.7.0",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-prettier": "^5.5.7",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.7",
    "eslint-plugin-sort-keys-fix": "1.1.2",
    "husky": "^9.1.7",
    "jest-axe": "^11.0.0",
    "jsdom": "30.1.2",
    "lint-staged": "^17.6.0",
    "postcss": "8.5.30",
    "prettier": "3.9.10",
    "prettier-plugin-tailwindcss": "0.8.1",
    "prop-types": "15.8.1",
    "start-server-and-test": "^3.0.13",
    "tailwindcss": "4.3.3",
    "tsx": "^4.23.15",
    "typescript": "6.0.3",
    "vite": "^8.3.4",
    "vite-plugin-checker": "0.14.5",
    "vite-plugin-eslint": "^1.8.1",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^5.0.4"
  },
  "overrides": {
    "dompurify": "^3.4.17",
    "d3-color": "3.1.0",
    "js-yaml": "^4.3.1",
    "mermaid": "^11.16.1",
    "eslint": {
      "minimatch": {
        "brace-expansion": "1.1.18"
      }
    },
    "eslint-plugin-import": {
      "minimatch": {
        "brace-expansion": "1.1.18"
      }
    },
    "eslint-plugin-jsx-a11y": {
      "minimatch": {
        "brace-expansion": "1.1.18"
      }
    },
    "eslint-plugin-react": {
      "minimatch": {
        "brace-expansion": "1.1.18"
      }
    },
    "@typescript-eslint/typescript-estree": {
      "minimatch": {
        "brace-expansion": "5.0.9"
      }
    },
    "react-simple-maps": {
      "react": "$react",
      "react-dom": "$react-dom"
    }
  }
}
